module.exports = (__webpack_require__(24))(238);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/rc-align/es/index.js from dll-reference lib_core
// module id = 848
// module chunks = 106